import { Box, Button, Flex, Text } from "@chakra-ui/react";

import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import routes from "../../../pages/routes";


const PaymentSuccessfulWallet = () => {

const navigate = useNavigate()

    return (
        <>
            <DashboardHeader />

            <Flex justifyContent="center" bg='#F9F8F8' height='95vh'>
                <Flex width='40%' bg='white' mb='200px' mt='100px' flexDirection='column' justifyContent="center" py='100px'>
                    <Box mx='auto' height='200px'>
                        <div className="dummy-positioning d-flex">

                            <div className="success-icon">
                                <div className="success-icon__tip"></div>
                                <div className="success-icon__long"></div>
                            </div>

                        </div>
                    </Box>
                    <Text fontSize='20px' textAlign='center' color='#353535'>Payment Successful</Text>
                    <Text textAlign='center' fontSize='14px' color='#4F4F4F' mb='30px'>Your account has been successfully funded</Text>
                    <Box mx='auto'>
                        <Button onClick={() => navigate(routes.WalletHistory)} py='13px' px='30px' type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>VIEW WALLET HISTORY</Button> 
                    </Box>

                </Flex >
            </Flex>
        </>
    );
}

export default PaymentSuccessfulWallet;